@if (iconName.includes('shrl')) {
    <mat-icon [svgIcon]="iconName"></mat-icon>
} @else {
    <mat-icon>{{ iconName }}</mat-icon>
}
